export default __webpack_public_path__ + "static/media/avatarWoman.6c880969.jfif";